"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.httpStatusCodes = void 0;
var httpStatusCodes = {
    OK: { errorType: 'Ok', statusCode: 200 },
    BAD_REQUEST: { errorType: 'BAD_REQUEST', statusCode: 400 },
    NOT_FOUND: { errorType: 'NOT_FOUND', statusCode: 404 },
    INTERNAL_SERVER: { errorType: 'INTERNAL-SERVER_ERROR', statusCode: 500 },
    NOT_ALLOWED: { errorType: 'NOT_ALLOWED', statusCode: 405 },
    NO_RESPONSE: { errorType: 'NO_RESPONSE', statusCode: 444 },
    NO_RESPONSE_RECEIVED: {
        errorType: 'NO_RESPONSE_RECEIVED',
        statusCode: 1 /* ErrorNames.E001 */,
    },
    NO_DATA_FOUND: { errorType: 'NO_DATA_FOUND', statusCode: 2 /* ErrorNames.E002 */ },
    NO_SUGGESTION_FOUND: {
        errorType: 'NO_SUGGESTION_FOUND',
        statusCode: 3 /* ErrorNames.E003 */,
    },
    NO_LOCALE: { errorType: 'NO_LOCALE', statusCode: 4 /* ErrorNames.E004 */ },
    NO_LONGITUDE: { errorType: 'NO_LONGITUDE', statusCode: 5 /* ErrorNames.E005 */ },
    NO_LATITUDE: { errorType: 'NO_LATITUDE', statusCode: 6 /* ErrorNames.E006 */ },
    NO_WINDOW: { errorType: 'NO_WINDOW', statusCode: 7 /* ErrorNames.E007 */ },
    NO_PARAMETER: { errorType: 'NO_PARAMETER', statusCode: 8 /* ErrorNames.E008 */ },
    NO_ADDRESS: { errorType: 'NO_ADDRESS', statusCode: 9 /* ErrorNames.E009 */ },
    NO_HANDLE: { errorType: 'NO_HANDLE', statusCode: 10 /* ErrorNames.E010 */ },
    UNKNOWN_ERROR: { errorType: 'UNKNOWN_ERROR', statusCode: 11 /* ErrorNames.E011 */ },
    NO_PARTNER_FOUND: {
        errorType: 'NO_PARTNER_FOUND',
        statusCode: 12 /* ErrorNames.E012 */,
    },
};
exports.httpStatusCodes = httpStatusCodes;
